// extracted by mini-css-extract-plugin
module.exports = {"ldsEllipsis":"styles_ldsEllipsis__3IGn1","lds-ellipsis1":"styles_lds-ellipsis1__2I4Ps","lds-ellipsis2":"styles_lds-ellipsis2__MUd1w","lds-ellipsis3":"styles_lds-ellipsis3__4RddI"};